module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-20GIU-25-small-d8f274180fd295b23848755ded7789bd.jpg";